import StayStudyPage from "../components/StayStudyPage";

export default function Stay6() {
  return (
    <StayStudyPage
      className="Class 6"
      heroTitle="Class 6 Stay & Study Program"
      heroDescription="A structured residential learning program focused on concept clarity, discipline, and independent learning."

      section1={{
        title: "📘 Strong Conceptual Foundation",
        description:
          "Class 6 introduces deeper academic concepts. Our program ensures clarity and confidence.",
        points: [
          "STATE|CBSE-aligned syllabus coverage",
          "Focus on Maths, Science, English & Social Science",
          "Concept explanation with examples",
          "Regular revision & worksheets",
          "Guided problem-solving sessions"
        ]
      }}

      section2={{
        title: "🗓️ Disciplined Daily Academic Routine",
        description:
          "A structured routine builds consistency, responsibility, and focus.",
        points: [
          "Supervised study hours",
          "Homework & revision support",
          "Balanced academics & rest",
          "Improved time management",
          "Distraction-free environment"
        ]
      }}

      whyUs={{
        title: "⭐ Why Choose ACCESS Stay & Study for Class 6?",
        description:
          "We support students during a key academic transition with care and discipline.",
        points: [
          "Experienced subject faculty",
          "24/7 supervised residential campus",
          "Daily monitored study sessions",
          "Regular tests & performance tracking",
          "Individual mentoring",
          "Nutritious food & safe hostel",
          "Focus on discipline & confidence"
        ]
      }}

      images={{
        section1: "/images/class5-2.jpg",
        section2: "/images/class5-1.jpg",
        whyUs: "/images/Hostel2.jpeg"
      }}

      fee="75,000"
      whatsappText="Hello ACCESS Team, I would like to enquire about the Class 6 Stay & Study Program."
    />
  );
}
